class ResourcesSort extends ViewBasic {
    constructor(options) {
        super(options);
    }

    init() {
        this.$filesContainer = this.$('.files-list-wrapper');
        this.$files = this.$('.files-list-item');
        this.sortedFiles;
        this.$orderingBtn = this.$('.files-ordering');
        this.addEvents();
    }

    addEvents() {
        this.$orderingBtn.on('click', (e) => this.fileSorting(e));
    }

    removeEvents() {
        this.$orderingBtn.off('click', (e) => this.fileSorting(e));
    }

    fileSorting(e) {
        let scope = this;
        let sortingByData = $(e.currentTarget).data('orderby');
        e.preventDefault();

        this.$files.each(function () {
            $(this).remove();
        });

        if(!$(e.currentTarget).hasClass('ascending')){
            // Sorting function => The localeCompare() method returns a number indicating whether a reference string comes before or after or is the same as the given string in sort order.
            this.sortedFiles = this.$files.sort((a,b) => $(a).data(sortingByData).localeCompare($(b).data(sortingByData)));
            this.$orderingBtn.each(function () {
                $(this).removeClass('ascending descending');
            });
            $(e.currentTarget).addClass('ascending');
        }
        else{
            this.sortedFiles = Array.prototype.reverse.call(this.$files);
            $(e.currentTarget).toggleClass('descending');
        }

        this.sortedFiles.each(function () {
            scope.$filesContainer.append(this);
        });
    }
}